<template lang="pug">
  .sub-attachment.xs-12
    .image-wrap.xs-4.md-3
      ProductInfoImage(:imagery="attachment.imagery")

    .info-wrap.xs-8.md-9
      .xs-10.md-12
        p.semi-bold.upper.xs-f-xsmall.max-at-tweak {{ attachment.productType || attachment.product_type_display_name }}
        p.color-slate.xs-f-xsmall.max-at-tweak(data-mr-ass="added-to-order-name") {{ attachment.name }}
        Pill(:text="invoiceItemTags.sub_addon")

      .qty-edit.xs-12(v-if="attachment.product_type != 'extra_tube'")
        span.xs-f-xsmall.max-at-tweak.upper qty:
        QtyButtons(:qty="attachment.qty" @qtyChange="onQtyChange")

    ConfirmDialog(@confirm="removeItem" confirm-text="Remove" title="Remove item" text="Your item will be removed from all upcoming shipments. Do you want to continue?")
      button.remove-item.transparent-btn.xs-f-large.max-at-tweak(type="button" aria-label="Remove Item" data-mr-ass="remove-xsell-button")
        span.icon-x.clickable

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ConfirmDialog from "../../../../ConfirmDialog";
  import ProductInfoImage from "../../ProductInfoImage";
  import QtyButtons from "../../../../QtyButtons";
  import Pill from "../../../../Pill";
  export default {
    name: "SubAttachment",
    components: {
      Pill,
      QtyButtons,
      ProductInfoImage,
      ConfirmDialog
    },

    data() {
      return {
        ctaSource: 'RCD Subscription Management'
      }
    },

    props: {
      attachment: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapState('constants', ['invoiceItemTags']),
    },

    methods: {
      ...mapActions('subscriptions', [
        'removeSubAttachment',
        'updateSubAttachmentQty'
      ]),

      removeItem() {
        let payload = {
          sub_id: this.attachment.sub_id,
          attachment_id: this.attachment.product_id,
          ctaSource: this.ctaSource
        };

        this.removeSubAttachment(payload);
      },

      onQtyChange(qty) {
        let { sub_id } = this.attachment;

        let payload = {
          sub_id,
          attachment_id: this.attachment.product_id,
          qty,
          ctaSource: this.ctaSource
        };

        this.updateSubAttachmentQty(payload);
      }
    }
  }
</script>

<style scoped lang="stylus">
  .sub-attachment
    position relative
    padding 1.5em 0

    .remove-item
      position absolute
      top 0.5em
      right 0
      color color-gray-triple-nines

    .info-wrap
      padding-left 1em

    .pill
      margin 1em 0 2em

    .qty-edit
      span
        padding-right 1em

</style>